var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Tabs, TabsItem } from 'telia-front-react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import customerIdAsKey from '../auth/customerIdAsKey';
import { MandateType } from '../config/mandate';
import CreditLimits from './CreditLimits';
import CustomerServicePassword from './CustomerServicePassword';
import PersonInfo from './PersonInfo';
import { createGaEvent } from '../util/GaUtil';
import { injectStores } from '../util/StoresUtil';
import { removeHashAndNavigate } from '../util/PathUtil';
import PrivacyPageLink from './PrivacyPageLink';
let PersonalDataTabs = class PersonalDataTabs extends Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "activeTab", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'person-info-tab'
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onTabItemChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (_, nextTab) => {
                removeHashAndNavigate(nextTab);
                this.activeTab = nextTab;
                createGaEvent({
                    eventCategory: 'Iseteenindus - Konto',
                    eventAction: 'Isikuandmed',
                    eventLabel: nextTab
                });
            }
        });
        makeObservable(this);
    }
    async componentDidMount() {
        await this.mandateStore.loadMandateInfo([MandateType.LEGAL, MandateType.SERVICE, MandateType.BILLING], false);
        removeHashAndNavigate(this.activeTab);
    }
    render() {
        const { translate } = this.translateStore;
        const { isRepresentingSelf } = this.ssoStore;
        const hasCorrectMandate = this.mandateStore.hasMandate([MandateType.LEGAL, MandateType.SERVICE, MandateType.BILLING], false);
        return (React.createElement(Tabs, { currentTab: this.activeTab, onTabChange: this.onTabItemChange, "aria-labelledby": "person-info-tabs", headingLevel: 3 },
            React.createElement(TabsItem, { id: "person-info-tab", label: translate('personInfo.tabLabel') },
                React.createElement(PersonInfo, null)),
            React.createElement(TabsItem, { id: "customer-data-processing-tab", label: translate('personGdpr.tabLabel.new') },
                React.createElement(PrivacyPageLink, null)),
            isRepresentingSelf && (React.createElement(TabsItem, { id: "customer-service-password-tab", label: translate('personPassword.tabLabel') },
                React.createElement(CustomerServicePassword, null))),
            hasCorrectMandate && (React.createElement(TabsItem, { id: "credit-limits-tab", label: translate('creditLimits.tabLabel') },
                React.createElement(CreditLimits, null)))));
    }
};
__decorate([
    observable
], PersonalDataTabs.prototype, "activeTab", void 0);
PersonalDataTabs = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], PersonalDataTabs);
export default PersonalDataTabs;
